import { MICROSITE_CDN_ASSETS_LINK_BASE } from '@lyrahealth-inc/shared-app-logic'

export const LyraSelectFooterDesktop = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectCloudsStarsBackgroundDesktop.png`,
}
export const LyraSelectFooterDesktopPlus = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectCloudsStarsBackgroundDesktopPlus.png`,
}
export const LyraSelectFooterLaptop = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectCloudsStarsBackgroundLaptop.png`,
}
export const LyraSelectFooterMobile = { uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectFooterMobile.png` }
export const LyraSelectFooterMobilePlus = { uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectFooterMobilePlus.png` }
export const LyraSelectFooterTablet = { uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectFooterTablet.png` }
export const MeetWithAnExpertImage = { uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/MeetWithAnExpert.png` }
export const MeetWithAnExpertImageLargeDefault = { uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/MeetWithAnExpertLarge.png` }
export const SoftSunriseMobileBG = { uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/SoftSunriseMobileBg.png` }
export const SoftSunriseWithDogBGBody = { uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/SoftSunriseWithDogBgBody.png` }
export const SoftSunriseWithDogBGFooter = { uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/SoftSunriseWithDogBgFooter.png` }
export const UnsubscribeEmailDog = { uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/UnsubscribeEmailDog.png` }
export const ContentLibraryImage = { uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/ContentLibrary.png` }
export const ContentLibraryImageLarge = { uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/ContentLibraryLarge.png` }
export const LyraSelectCareNavigator = { uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectCareNavigator.png` }
export const LyraSelectMobilePromo = { uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectMobilePromo.png` }
export const LyraSelectPromo = { uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectPromo.png` }
export const ComingSoonMicrositeBackgroundMobile = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/comingSoonMicrositeBackgroundMobile.png`,
}
export const ComingSoonMicrositeBackgroundDesktop = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/comingSoonMicrositeBackgroundDesktop.png`,
}
export const LyraSelectComingSoonHeaderMobile = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectComingSoonHeaderMobile.png`,
}
export const LyraSelectMicrositeHeaderMobile = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectMicrositeHeaderMobile.png`,
}
export const LyraSelectComingSoonHeaderMobilePlus = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectComingSoonHeaderMobilePlus.png`,
}
export const LyraSelectMicrositeHeaderMobilePlus = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectMicrositeHeaderMobilePlus.png`,
}
export const LyraSelectComingSoonHeaderTablet = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectComingSoonHeaderTablet.png`,
}
export const LyraSelectMicrositeHeaderTablet = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectMicrositeHeaderTablet.png`,
}
export const LyraSelectComingSoonHeaderLaptop = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectComingSoonHeaderLaptop.png`,
}
export const LyraSelectMicrositeHeaderLaptop = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectMicrositeHeaderLaptop.png`,
}
export const LyraSelectComingSoonHeaderDesktop = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectComingSoonHeaderDesktop.png`,
}
export const LyraSelectMicrositeHeaderDesktop = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectMicrositeHeaderDesktop.png`,
}
export const LyraSelectComingSoonHeaderDesktopPlus = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectComingSoonHeaderDesktopPlus.png`,
}
export const LyraSelectMicrositeHeaderDesktopPlus = {
  uri: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectMicrositeHeaderDesktopPlus.png`,
}
